<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex items-center gap-3 min-w-0 flex-1">
            <ReflectionIcon kind="team" size="md" />
            <div class="flex flex-col gap-1 min-w-0">
                <div class="flex items-center gap-2.5 flex-wrap">
                    <span class="body-semibold text-ink">Give 360 feedback to {{ request.subject_first_name }}</span>
                    <FeatureChip feature="team-reflect">Team Review</FeatureChip>
                </div>
                <div class="scaffold-body-small text-ink-muted">Requested by {{ request.subject_first_name }} · Anonymous</div>
            </div>
        </div>
        <a
            :href="`/reflections/360/r/${request.invite_token}/`"
            class="base-btn-neutral base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            :aria-label="`${GIVE_FEEDBACK_TEXT} to ${request.subject_first_name}`"
            @click.prevent="emit('give-feedback', request)">
            {{ GIVE_FEEDBACK_TEXT }}
        </a>
    </BaseCard>
</template>

<script setup lang="ts">
import type { TeamReflectionRequest } from "~vue/api/generated/reflections";
import BaseCard from "~vue/components/BaseCard.vue";
import FeatureChip from "~vue/components/FeatureChip.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";

const GIVE_FEEDBACK_TEXT = "Give feedback";

interface Props {
    request: TeamReflectionRequest;
}

defineProps<Props>();
const emit = defineEmits<{ (event: "give-feedback", request: TeamReflectionRequest): void }>();
</script>
